import { DateTime } from 'luxon';

const getServerTime = (time: number) => {
    return DateTime.fromSeconds(time).toUTC().toFormat('HH:mm:ss');
}

export default getServerTime;